import React from 'react';
import PromoCodeForm from './form';

const PromoCode = (props) => {
  if (props.promoFormVisible) {
    return (
      <PromoCodeForm
        scriptPath={props.staticData.site.script_path}
        context={props.staticData.miscellaneous.context}
        onClick={() => props.togglePromoCodeForm()}
        currentProduct={props.currentProduct}
        errorVisible={props.errorVisible}
        localisations={props.localisations}
      />
    );
  }
  return (
    <button
      className="checkout__display-promo-form"
      onClick={() => props.togglePromoCodeForm()}
    >
      {props.localisations.i_have_a_promo_code}
    </button>
  );
};

export default PromoCode;
